import React from 'react'
// import {makeStyles} from '@material-ui/core/styles'
import {Alert, AlertTitle} from '@material-ui/lab'

// const useStyles = makeStyles(theme => ({
//   root: {
//     width: '100%',
//     '& > * + *': {
//       marginTop: theme.spacing(2),
//     },
//   },
// }))

export default function StepPaymentSuccess(props) {
  // const classes = useStyles()
  const {
    title = 'Grazie per aver scelto una vacanza studio o soggiorno estivo GIOCAMONDO',
    message = "Ti invieremo a breve una mail di conferma, nel frattempo puoi verificare l’accuratezza dei dati inseriti all’interno della sezione Contratti e Documenti in area riservata. Se necessario, potrai modificarli autonomamente"
    } = props

  return (
    // <div className={classes.root}>
    <Alert severity="success">
      <AlertTitle>{title}</AlertTitle>
      {message}
    </Alert>
    // </div>
  )
}
